import constants from '../../../../constants.js';

// import React, { useEffect, useState, useContext } from "react";
// import { Box } from "@material-ui/core";
// import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
// import AlertContext from "../../../../context/AlertContext";
// import { getDataFromStorage } from "../../../../util";
// import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
// import { useParams } from "react-router-dom";
// import CircularProgress from '@mui/material/CircularProgress';

// const DbPercentages = () => {
//     const axios = useAxiosPrivate();
//     const Alert = useContext(AlertContext);
//     const [avgAttendance, setAvgAttendance] = useState("");
//     const [avgScore, setAvgScore] = useState("");
//     const [testsComplete, setTestsComplete] = useState("");
//     const { id } = useParams();
//     const {getCatchBlockDetails, getHeaderDetailsForAxios} = useCommonFunctionHooks();
//     const [isLoadingAttendance, setIsLoadingAttendance] = useState(false);
//     const [isLoadingScore, setIsLoadingScore] = useState(false);
//     const [isLoadingTests, setIsLoadingTests] = useState(false);

// useEffect(() => {
//     const fetchBatchData = async () => {
//       try {
//         setIsLoadingAttendance(true);
//         setIsLoadingScore(true);
//         setIsLoadingTests(true);
//         const [attendanceRes, scoreRes, testsRes] = await Promise.all([
//           axios.get(`node/admin/batch/db/avg_attendance`,

//             {
//                 params:{batchid: id},
//           headers: {
//             "Content-type": "application/json",
//           },
//         }).finally(() => setIsLoadingAttendance(false)),
//           axios.get(`node/admin/batch/db/avg_score`,
//             {
//                 params:{batchid: id},
//           headers: {
//             "Content-type": "application/json",
//           },
//         }).finally(() => setIsLoadingScore(false)),
//           axios.get(`node/admin/batch/db/tests_complete`,
//             {
//             params:{batchid: id},
//           headers: {
//             "Content-type": "application/json",
//           },
//         }).finally(() => setIsLoadingTests(false)),
//         ]);

//         setAvgAttendance(attendanceRes.data.data?.avgAttendance);
//         setAvgScore(scoreRes.data.data?.avgTestScore);
//         setTestsComplete(testsRes.data.data?.avgTestCompleted);
//       } catch (error) {
//         console.error('Error fetching batch data:', error);
//       }
//     };

//     fetchBatchData();
//   }, [id]);

//  return (
//   <>

//   <div className="batchdashboardAveragePercentageContainer">
//   <div className="batchaverageattendance">
//     {isLoadingAttendance || avgAttendance === "0" ?(
//  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//   <CircularProgress />
// </div>

//   ):(
//     <>
//   <span className="batchaverageattendanceheader">Average Attendance</span>
//   <span className= {avgAttendance === "0.00"?"batchaverageattendanceInnerdiv" : "averagesattendance"}>
//  {avgAttendance === "0.00" ?"Start tracking once activity begins": `${avgAttendance}%`}
//    </span>
//    </>
//   )}
//   </div>

//   <div className="batchaverageattendance">
//     {isLoadingTests || testsComplete === "0"? (
//  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//   <CircularProgress />
//   </div>
//   ):(
//     <>
//   <span className="batchaverageattendanceheader">Assignment Completion</span>
//   <span className={testsComplete === "0.00"?"batchaverageattendanceInnerdiv":"averagetestcompleted"}>
//  {testsComplete === "0.00" ?"Start tracking once activity begins":`${testsComplete}%`}
//   </span>
//   </>
//   )}
//   </div>

//   <div className="batchaverageattendance">
//     {isLoadingScore || avgScore === "0"?(
//   <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//   <CircularProgress />
// </div>

//   ):(
//     <>
//   <span className="batchaverageattendanceheader">Average Score (100)</span>
//   <span className={avgScore === "0.00"?"batchaverageattendanceInnerdiv":"averageScore"}>
//  {avgScore === "0.00" ? "Start tracking once activity begins" : avgScore}
//   </span>

//   </>
//   )}
//   </div>
//   </div>
//   </>
//   );

// };
// export default DbPercentages;

import React, { useEffect, useState, useContext } from "react";
import { Box } from "@material-ui/core";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../../context/AlertContext";
import { getDataFromStorage } from "../../../../util";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

const DbPercentages = ({ learners, isLoadingTop }) => {
  const axios = useAxiosPrivate();
  const Alert = useContext(AlertContext);
  const [avgAttendance, setAvgAttendance] = useState("");
  const [avgScore, setAvgScore] = useState("");
  const [testsComplete, setTestsComplete] = useState("");
  const { id } = useParams();
  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();
  const [isLoadingAttendance, setIsLoadingAttendance] = useState(false);
  const [isLoadingScore, setIsLoadingScore] = useState(false);
  const [isLoadingTests, setIsLoadingTests] = useState(false);

  useEffect(() => {
    const fetchBatchData = async () => {
      try {
        setIsLoadingAttendance(true);
        setIsLoadingScore(true);
        setIsLoadingTests(true);
        const [attendanceRes, scoreRes, testsRes] = await Promise.all([
          axios
            .get(
              `node/admin/batch/db/avg_attendance`,

              {
                params: { batchid: id },
                headers: {
                  "Content-type": "application/json",
                },
              }
            )
            .finally(() => setIsLoadingAttendance(false)),
          axios
            .get(`node/admin/batch/db/avg_score`, {
              params: { batchid: id },
              headers: {
                "Content-type": "application/json",
              },
            })
            .finally(() => setIsLoadingScore(false)),
          axios
            .get(`node/admin/batch/db/tests_complete`, {
              params: { batchid: id },
              headers: {
                "Content-type": "application/json",
              },
            })
            .finally(() => setIsLoadingTests(false)),
        ]);

        setAvgAttendance(attendanceRes.data.data?.avgAttendance);
        setAvgScore(scoreRes.data.data?.avgTestScore);
        setTestsComplete(testsRes.data.data?.avgTestCompleted);
      } catch (error) {
        console.error("Error fetching batch data:", error);
      }
    };

    fetchBatchData();
  }, [id]);

  return (
    <>
      <div className="batchdashboardAveragePercentageContainer">
        <div
          className={
            learners === "0"
              ? "batchstartingattendance"
              : "batchaverageattendance"
          }
        >
          {isLoadingTop || learners === "0" ? (
            <div className="loadingIndicatorDiv">
              <CircularProgress />
            </div>
          ) : (
            <>
              <span className="batchaverageattendanceheader">Learners</span>
              <span
                className={
                  learners === "0" || learners === ""
                    ? "batchaverageattendanceInnerdiv"
                    : "learnerscount"
                }
              >
                {learners === "0" || learners === ""
                  ? "Start tracking once activity begins"
                  : learners}
              </span>
            </>
          )}
        </div>
        {constants.BATCH_TYPE.TESTING!=sessionStorage.getItem("batchType") && <div
          className={
            avgAttendance === "0.00"
              ? "batchstartingattendance"
              : "batchaverageattendance"
          }
        >
          {isLoadingAttendance || avgAttendance === "0" ? (
            <div className="loadingIndicatorDiv">
              <CircularProgress />
            </div>
          ) : (
            <>
              <span className="batchaverageattendanceheader">
                Average Attendance
              </span>
              <span
                className={
                  avgAttendance === "0.00"
                    ? "batchaverageattendanceInnerdiv"
                    : "averagesattendance"
                }
              >
                {avgAttendance === "0.00"
                  ? "Start tracking once activity begins"
                  : `${avgAttendance}%`}
              </span>
            </>
          )}
        </div>}

        <div
          className={
            testsComplete === "0.00"
              ? "batchstartingattendance"
              : "batchaverageattendance"
          }
        >
          {isLoadingTests || testsComplete === "0" ? (
            <div className="loadingIndicatorDiv">
              <CircularProgress />
            </div>
          ) : (
            <>
              <span className="batchaverageattendanceheader">
                Assignment Completion
              </span>
              <span
                className={
                  testsComplete === "0.00"
                    ? "batchaverageattendanceInnerdiv"
                    : "averagetestcompleted"
                }
              >
                {testsComplete === "0.00"
                  ? "Start tracking once activity begins"
                  : `${testsComplete}%`}
              </span>
            </>
          )}
        </div>

        <div
          className={
            avgScore === "0.00"
              ? "batchstartingattendance"
              : "batchaverageattendance"
          }
        >
          {isLoadingScore || avgScore === "0" ? (
            <div className="loadingIndicatorDiv">
              <CircularProgress />
            </div>
          ) : (
            <>
              <span className="batchaverageattendanceheader">
                Average Score (100)
              </span>
              <span
                className={
                  avgScore === "0.00"
                    ? "batchaverageattendanceInnerdiv"
                    : "averageScore"
                }
              >
                {avgScore === "0.00"
                  ? "Start tracking once activity begins"
                  : avgScore}
              </span>
            </>
          )}
        </div>
        
      </div>
    </>
  );
};
export default DbPercentages;
